/* v5-bundle-extras-toggle-2026-05-29-1745 */
/* =====================================================
   Chesto Bundels — minimal JS
   - Bundle option (variant) selection on the PDP
   - Quantity stepper
   - Gallery thumbnail switching
   - Updates price totals + hidden form input for ATC
   ===================================================== */

(function () {
  'use strict';

  /* -------- helpers -------- */
  function formatMoneyEUR(cents) {
    // Dutch convention: € 449,– for round euros, € 449,99 for fractions
    var value = cents / 100;
    if (Math.round(value) === value) {
      return '€\u00A0' + value + ',\u2013';
    }
    return '€\u00A0' + value.toFixed(2).replace('.', ',');
  }

  /* =====================================================
     Bundle option (variant) picker
     Each option-label wraps a hidden radio input[name="id"]
     ===================================================== */
  function initBundlePicker(root) {
    var inputs = root.querySelectorAll('.chesto-option__input');
    if (!inputs.length) return;

    var totalsPrice = root.querySelector('[data-chesto-total-price]');
    var totalsOld   = root.querySelector('[data-chesto-total-old]');
    var totalsSaved = root.querySelector('[data-chesto-total-saved]');
    var addBtn      = root.querySelector('[data-chesto-add-btn]');
    var extrasRoot  = root.querySelector('[data-chesto-extras]');
    var belowRoot   = root.querySelector('[data-chesto-below]');

    function syncTotals() {
      var selected = root.querySelector('.chesto-option__input:checked');
      if (!selected) return;
      var price = parseInt(selected.dataset.price, 10);
      var compare = parseInt(selected.dataset.compare || '0', 10) || 0;
      var available = selected.dataset.available === 'true';
      var variantId = selected.value;

      if (totalsPrice) totalsPrice.textContent = formatMoneyEUR(price);
      if (totalsOld) {
        if (compare > price) {
          totalsOld.textContent = formatMoneyEUR(compare);
          totalsOld.style.display = '';
        } else {
          totalsOld.style.display = 'none';
        }
      }
      if (totalsSaved) {
        if (compare > price) {
          totalsSaved.textContent = 'Bespaar ' + formatMoneyEUR(compare - price);
          totalsSaved.style.display = '';
        } else {
          totalsSaved.style.display = 'none';
        }
      }
      if (addBtn) {
        if (available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.dataset.labelAvailable || 'In winkelmandje';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.labelSoldOut || 'Uitverkocht';
        }
      }
      // Toggle extras gallery: show only the row of the selected variant
      if (extrasRoot) {
        var rows = extrasRoot.querySelectorAll('.chesto-bundle-extras__row');
        rows.forEach(function (row) {
          if (row.getAttribute('data-variant-id') === variantId) {
            row.classList.add('is-active');
          } else {
            row.classList.remove('is-active');
          }
        });
      }
      // Toggle "Wat je krijgt" below-the-fold: show only the row of the selected variant
      if (belowRoot) {
        var belowRows = belowRoot.querySelectorAll('[data-chesto-below-row]');
        belowRows.forEach(function (row) {
          if (row.getAttribute('data-variant-id') === variantId) {
            row.classList.add('is-active');
          } else {
            row.classList.remove('is-active');
          }
        });
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', syncTotals);
    });

    syncTotals();
  }

  /* =====================================================
     Quantity stepper
     ===================================================== */
  function initQtySteppers(root) {
    var groups = root.querySelectorAll('[data-chesto-qty]');
    groups.forEach(function (group) {
      var input = group.querySelector('input[name="quantity"]');
      var val = group.querySelector('[data-chesto-qty-val]');
      var dec = group.querySelector('[data-chesto-qty-dec]');
      var inc = group.querySelector('[data-chesto-qty-inc]');

      function sync() {
        var n = parseInt(input.value, 10);
        if (isNaN(n) || n < 1) n = 1;
        input.value = n;
        if (val) val.textContent = n;
        if (dec) dec.disabled = n <= 1;
      }

      if (dec) dec.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = Math.max(1, parseInt(input.value, 10) - 1);
        sync();
      });
      if (inc) inc.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = parseInt(input.value, 10) + 1;
        sync();
      });

      sync();
    });
  }

  /* =====================================================
     Gallery thumbnail switcher
     ===================================================== */
  function initGallery(root) {
    var galleries = root.querySelectorAll('[data-chesto-gallery]');
    galleries.forEach(function (g) {
      var main = g.querySelector('[data-chesto-gallery-main]');
      var counter = g.querySelector('[data-chesto-gallery-counter]');
      var thumbs = g.querySelectorAll('[data-chesto-thumb]');
      if (!main || !thumbs.length) return;

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('chesto-thumb--active'); });
          t.classList.add('chesto-thumb--active');
          var src = t.dataset.full || t.querySelector('img').src;
          main.src = src;
          if (counter) {
            var total = thumbs.length;
            counter.textContent = (i + 1) + ' / ' + total;
          }
        });
      });
    });
  }

  /* =====================================================
     Filter chips: show/hide grid sections + auto counts
     ===================================================== */
  function initFilters() {
    var filterBar = document.querySelector('[data-chesto-filters]');
    if (!filterBar) return;
    var chips = filterBar.querySelectorAll('[data-chesto-chip]');
    var grids = document.querySelectorAll('[data-chesto-grid]');
    if (!chips.length || !grids.length) return;

    function countCardsIn(grid) {
      // count rendered bundle cards (real or demo) inside this grid
      var cards = grid.querySelectorAll('.chesto-bcard, .chesto-bundle-card');
      return cards.length;
    }

    function updateCounts() {
      var total = 0;
      var byCat = {};
      grids.forEach(function (g) {
        var cat = (g.getAttribute('data-chesto-category') || '').toLowerCase().trim();
        var n = countCardsIn(g);
        byCat[cat] = (byCat[cat] || 0) + n;
        total += n;
      });
      chips.forEach(function (chip) {
        var f = (chip.getAttribute('data-chesto-filter') || '').toLowerCase().trim();
        var countEl = chip.querySelector('[data-chesto-chip-count]');
        if (!countEl) return;
        var n = (f === 'all') ? total : (byCat[f] || 0);
        countEl.textContent = n > 0 ? n : '';
      });
    }

    function applyFilter(filterVal) {
      var f = (filterVal || 'all').toLowerCase().trim();
      grids.forEach(function (g) {
        var cat = (g.getAttribute('data-chesto-category') || '').toLowerCase().trim();
        var match = (f === 'all') || (cat === f) || (cat.indexOf(f) !== -1) || (f.indexOf(cat) !== -1);
        g.style.display = match ? '' : 'none';
      });
      chips.forEach(function (c) {
        c.classList.toggle(
          'chesto-chip--active',
          (c.getAttribute('data-chesto-filter') || '').toLowerCase().trim() === f
        );
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        var f = chip.getAttribute('data-chesto-filter');
        applyFilter(f);
        // smooth scroll to top of bundles area
        var anchor = document.getElementById('chesto-bundles-top');
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    updateCounts();
    // Default: show all
    applyFilter('all');
  }

  /* =====================================================
     Init on DOM ready (and re-init on Shopify section reload)
     ===================================================== */
  function init() {
    var roots = document.querySelectorAll('.chesto-bundle-root');
    roots.forEach(function (root) {
      initBundlePicker(root);
      initQtySteppers(root);
      initGallery(root);
    });
    initFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', init);
})();
